/**
 * MinaRoMina Mobile Menu Fix
 * Solución robusta con event delegation y compatibilidad con Shopify theme editor
 */

(function() {
  'use strict';

  console.log('[MM Mobile Menu] Script loaded');

  function initMobileMenu() {
    console.log('[MM Mobile Menu] Initializing...');

    // Verificar que los elementos existan
    const toggle = document.querySelector('.mm-header__mobile-toggle');
    const menu = document.querySelector('.mm-mobile-menu');

    console.log('[MM Mobile Menu] Toggle found:', toggle);
    console.log('[MM Mobile Menu] Menu found:', menu);
    console.log('[MM Mobile Menu] Total toggles:', document.querySelectorAll('.mm-header__mobile-toggle').length);

    if (!toggle || !menu) {
      console.warn('[MM Mobile Menu] Elements not found, retrying in 100ms...');
      setTimeout(initMobileMenu, 100);
      return;
    }

    // Asegurar z-index y pointer-events en el toggle
    toggle.style.zIndex = '999';
    toggle.style.pointerEvents = 'auto';
    toggle.style.position = 'relative';

    console.log('[MM Mobile Menu] Elements ready, setting up listeners');
  }

  function openMenu() {
    console.log('[MM Mobile Menu] Opening menu');
    const menu = document.querySelector('.mm-mobile-menu');
    const toggle = document.querySelector('.mm-header__mobile-toggle');

    if (!menu || !toggle) return;

    menu.classList.add('mm-mobile-menu--open');
    toggle.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');

    // CRITICAL FIX: Fuerza body overflow a visible para permitir position:fixed
    document.body.style.setProperty('overflow', 'visible', 'important');

    console.log('[MM Mobile Menu] Menu opened, classes:', menu.className);
  }

  function closeMenu() {
    console.log('[MM Mobile Menu] Closing menu');
    const menu = document.querySelector('.mm-mobile-menu');
    const toggle = document.querySelector('.mm-header__mobile-toggle');

    if (!menu || !toggle) return;

    menu.classList.remove('mm-mobile-menu--open');
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');

    // Restaura el overflow original removiendo el inline style
    document.body.style.removeProperty('overflow');

    console.log('[MM Mobile Menu] Menu closed');
  }

  // CRITICAL FIX: Forzar body overflow visible en Shopify design mode
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.body.style.setProperty('overflow', 'visible', 'important');
  }

  // Event delegation en document para evitar problemas con Shopify
  document.addEventListener('click', function(e) {
    // Click en toggle hamburguesa
    if (e.target.closest('.mm-header__mobile-toggle')) {
      console.log('[MM Mobile Menu] Toggle clicked!');
      e.preventDefault();
      e.stopPropagation();
      openMenu();
      return;
    }

    // Click en close button
    if (e.target.closest('.mm-mobile-menu__close')) {
      console.log('[MM Mobile Menu] Close button clicked');
      e.preventDefault();
      closeMenu();
      return;
    }

    // Click en overlay
    if (e.target.classList.contains('mm-mobile-menu__overlay')) {
      console.log('[MM Mobile Menu] Overlay clicked');
      closeMenu();
      return;
    }

    // Click en submenu toggle (acordeón nivel 1)
    const toggleBtn = e.target.closest('.mm-mobile-menu__toggle');
    if (toggleBtn) {
      console.log('[MM Mobile Menu] Submenu toggle clicked');
      e.preventDefault();
      e.stopPropagation();

      const submenuId = toggleBtn.getAttribute('aria-controls');
      const submenu = document.getElementById(submenuId);
      const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

      // Toggle estado
      toggleBtn.setAttribute('aria-expanded', !isExpanded);
      submenu.setAttribute('aria-hidden', isExpanded);

      console.log('[MM Mobile Menu] Submenu toggled:', submenuId, 'expanded:', !isExpanded);
      return;
    }

    // Click en submenu toggle nivel 2 (acordeón nivel 2 - ej. COLECCIONES)
    const toggleBtnL2 = e.target.closest('[data-submenu-toggle-l2]');
    if (toggleBtnL2) {
      console.log('[MM Mobile Menu] Level 2 submenu toggle clicked');
      e.preventDefault();
      e.stopPropagation();

      const submenuId = toggleBtnL2.getAttribute('aria-controls');
      const submenu = document.getElementById(submenuId);
      const isExpanded = toggleBtnL2.getAttribute('aria-expanded') === 'true';

      // Toggle estado
      toggleBtnL2.setAttribute('aria-expanded', !isExpanded);
      submenu.setAttribute('aria-hidden', isExpanded);

      console.log('[MM Mobile Menu] Level 2 submenu toggled:', submenuId, 'expanded:', !isExpanded);
      return;
    }

    // Click en link simple del menú (no toggle) - cierra el menú
    const simpleLink = e.target.closest('.mm-mobile-menu__link:not(.mm-mobile-menu__toggle)');
    if (simpleLink) {
      console.log('[MM Mobile Menu] Simple menu link clicked');
      closeMenu();
      return;
    }

    // Click en submenu link - cierra el menú
    if (e.target.closest('.mm-mobile-menu__sublink')) {
      console.log('[MM Mobile Menu] Submenu link clicked');
      closeMenu();
      return;
    }
  }, true); // useCapture = true para capturar el evento antes que otros handlers

  // Cerrar con ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const menu = document.querySelector('.mm-mobile-menu');
      if (menu && menu.classList.contains('mm-mobile-menu--open')) {
        console.log('[MM Mobile Menu] ESC pressed, closing');
        closeMenu();
      }
    }
  });

  // Inicializar en DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }

  // Reinicializar cuando Shopify carga/recarga secciones (theme editor)
  document.addEventListener('shopify:section:load', function(e) {
    console.log('[MM Mobile Menu] Shopify section loaded:', e.detail);
    initMobileMenu();
  });

  document.addEventListener('shopify:section:reorder', function() {
    console.log('[MM Mobile Menu] Shopify section reordered');
    initMobileMenu();
  });

  // Exportar funciones globalmente para debugging
  window.mmMobileMenu = {
    open: openMenu,
    close: closeMenu,
    init: initMobileMenu
  };

  console.log('[MM Mobile Menu] Setup complete. Test with: window.mmMobileMenu.open()');
})();
